/* global axios */
import ApiClient from '../ApiClient';

// Ba tab của trang CRM. Đi qua ApiClient của Chatwoot chứ KHÔNG dùng `fetch`
// trần: xác thực là header devise-token-auth (access-token / client / uid) do
// axios interceptor gắn vào, không phải cookie phiên. Gọi fetch thẳng thì server
// trả 401 dù đang đăng nhập.
class BonbozApi extends ApiClient {
  constructor(duong) {
    super(`bonboz/${duong}`, { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id, params = {}) {
    return axios.get(`${this.url}/${id}`, { params });
  }
}

export const khachApi = new BonbozApi('ad_touchpoints');
export const adApi = new BonbozApi('ads');
export const inboxApi = new BonbozApi('inbox_messages');
